<template>
  <van-tabbar 
    v-model="activeIndex" 
    active-color="#4caf50" 
    inactive-color="#666"
    @change="onChange"
  >
    <van-tabbar-item name="Home" icon="home-o">首页</van-tabbar-item>
    <van-tabbar-item name="MyMeetings" icon="calendar-o">会议</van-tabbar-item>
    <van-tabbar-item name="Profile" icon="user-o">个人中心</van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  name: 'BottomNavigation',
  data() {
    return {
      activeIndex: 'Home'
    };
  },
  watch: {
    // 监听路由变化，更新选中的标签页
    '$route'(to) {
      this.updateActiveIndex(to.name);
    }
  },
  mounted() {
    // 初始化时根据当前路由设置选中项
    this.updateActiveIndex(this.$route.name);
  },
  methods: {
    updateActiveIndex(routeName) {
      this.activeIndex = routeName || 'Home';
    },
    onChange(name) {
      // 根据选中的标签页名称跳转路由
      const routeMap = {
        Home: '/home',
        MyMeetings: '/my-meetings',
        Profile: '/profile'
      };
      
      if (routeMap[name] && this.$route.path !== routeMap[name]) {
        this.$router.push(routeMap[name]);
      }
    }
  }
};
</script>

<style scoped>
/* 可以保留一些自定义样式，或者根据需要添加 */
</style>